module.exports = __webpack_public_path__ + "static/media/3.e2da27d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hair/3.png
// module id = 1263
// module chunks = 0